<template>
  <div>
    <el-popover
        style="position: absolute;right: 40px;"
        placement="bottom"
        width="550"
        trigger="click">
      <el-table :data="tmpOrders" id="tmp-order-table">
        <el-table-column width="200" prop="customer_name" :show-overflow-tooltip="true"
                         label="客户名称"/>
        <el-table-column width="100" prop="brand" :show-overflow-tooltip="true" label="品牌"/>
        <el-table-column width="100" prop="product" :show-overflow-tooltip="true"
                         label="产品"/>
        <el-table-column width="150" label="操作">
          <template slot-scope="scope">
            <el-button
                style="padding: 0 0"
                type="text"
                size="mini"
                @click="goEditTmp(scope.row,scope.$index)"
            >编辑
            </el-button>
            <el-button
                style="padding: 0 0"
                type="text"
                size="mini"
                @click="deleteTmpOrders(scope.$index)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-badge slot="reference" :value="tmpOrderNum" class="item">
        <el-button size="mini">暂存订单</el-button>
      </el-badge>
    </el-popover>
  </div>
</template>

<script>
import {temporariesList, temporariesSave} from "@/api/order";

export default {
  name: "TempOrderView",
  data() {
    return {
      tmpOrderNum: 0,
      tmpOrders: [],
    }
  },
  computed: {},
  mounted() {
    this.getTmpOrders()
  },
  methods: {
    async getTmpOrders() {
      const {model} = await temporariesList()
      const array = model || []
      this.tmpOrders = array
      this.tmpOrderNum = array.length > 99 ? '99+ ' : array.length
    },
    goEditTmp(row, index) {
      const {href} = this.$router.resolve({
        name: `createAdOrder`,
        query: {type: "tmp", tmpIndex: index}
      });
      window.open(href, "_blank");
    },
    deleteTmpOrders: function (index) {
      this.showModal({
        h: this,
        text: "确定删除吗",
        confirmText: "",
        cancelText: "",
        confirm: async () => {
          this.showToast({
            h: this
          })
          this.tmpOrders.splice(index, 1)
          this.tmpOrderNum = this.tmpOrderNum - 1;
          const response = await temporariesSave({orders: this.tmpOrders})
          if (!response.success) {
            this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
            return;
          }
          this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
        },
        cancel: () => {
        }
      });
    },
  }
}
</script>

<style scoped>
.tmp-order-num {
  background-color: rgb(254, 45, 84);
  border-radius: 50%;
  width: 20px;
  line-height: 1;
  color: #fff;
  font-size: 12px;
}
</style>
<style>
#tmp-order-table thead tr, #tmp-order-table thead th {
  line-height: 27px;
  background: #f9f9f9 !important;
  color: #313337 !important;
}

#import-order-table thead tr, #import-order-table thead th {
  height: 30px;
  line-height: 27px;
  background: #f2f2f2 !important;
  color: #313337 !important;
}
</style>